import { type ValueOf } from '../utils/type'

/**
 * 1: check mark
 * 2: exclamation mark(when case inquiry is eligible)
 */
export const CASE_INQUIRY_ICON_TYPE_MAP = {
  checkMark: 1,
  exclamationMark: 2,
} as const

export const VISA_BULLETIN_ICON_TYPE_MAP = {
  checkMark: 1,
  info: 2,
  hourglass: 3,
}

export interface CaseHistoryItem {
  message: string
  received_date: string
  title: string
  type: CaseHistoryType
}

export interface CaseLastStatus {
  contents: string
  receivedDate: string
  status: string
  title: string
}

export type CaseInquiryIconType = ValueOf<typeof CASE_INQUIRY_ICON_TYPE_MAP>
export type VisaBulletinIconType = ValueOf<typeof VISA_BULLETIN_ICON_TYPE_MAP>

export type VisaBulletinFilingDateType = 'Date' | 'C'
export type VisaBulletinFinalActionDateType = 'Date' | 'C' | 'U'

export type CaseApplicationType = 'uscis' | 'nvc' | 'dol'
export type CaseHistoryType = 'status' | 'history'
